import { Avatar, Button, Card, Heading, If, Input, Progress, Stack, Text, View } from '@fold-dev/core'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { logger } from '../helpers/util'
import { useUserEmails, useWorkspaceInvites, useWorkspaces, useWorkspaceUsers } from '../hooks/api.hooks'
import { Logo, LogoF, LogoNew } from '../logo'
import { useSearchParams } from 'react-router-dom'

export const ConfirmEmailLayout = (props) => {
    const [error, setError] = useState<any>(null)
    const [loading, setLoading] = useState(false)
    const [searchParams] = useSearchParams()
    const token = searchParams.get('token')
    const navigate = useNavigate()
    const userEmailsAPI = useUserEmails()

    useEffect(() => {
        ;(async () => {
            if (!token) return
            setLoading(true)
            try {
                await userEmailsAPI.confirm({ token })
                setLoading(false)
            } catch (e) {
                logger(e)
                setLoading(false)
                setError('Something has gone wrong')
            }
        })()
    }, [token])

    return (
        <View
            column
            width="100%"
            height="100%"
            position="absolute"
            bg="linear-gradient(45deg, var(--f-color-surface), var(--f-color-surface-strong))">
            <If if={loading}>
                <Progress
                    value={50}
                    thickness={5}
                    indeterminate
                    bgToken="transparent"
                    position="absolute"
                    variant="success"
                    style={{
                        '--f-progress-radius': 0,
                        'top': 0,
                        'left': 0,
                    }}
                />
            </If>

            <Card
                column
                p={50}
                width={400}
                className="workspace-page">
                <View p="0 0 2rem 0">
                    <LogoNew
                        scale={0.5}
                        color="var(--f-color-text)"
                    />
                </View>

                <Stack
                    direction="vertical"
                    spacing={20}
                    justifyContent="center"
                    noStretch>
                    <Text
                        textAlign="center"
                        size="lg">
                        Congratulations!
                    </Text>
                    <Text textAlign="center">Your email address has been confirmed.</Text>
                    <Button
                        onClick={() => navigate('/auth')}
                        size="xl"
                        variant="accent"
                        disabled={loading}>
                        Launch App
                    </Button>
                    <If if={error}>
                        <Text
                            size="sm"
                            fontWeight="bold"
                            onClick={() => setError(null)}
                            colorToken="danger">
                            {error}
                        </Text>
                    </If>
                </Stack>
            </Card>
        </View>
    )
}
